








import Vue from 'vue';
import { SUGGEST_URL } from '@/constants';
import { debounce } from '@/util/util';

export default Vue.extend({

  props: {
    searchString: String,
    active: Boolean,
  },

  data() {
    return {
      suggestions: [],
    }
  },

  watch: {
    searchString: debounce(function (this: any, e: { target: HTMLInputElement }) {
      this.suggestions = [];
      if (this.active) {
        // User typed something. Autosuggest.
        Vue.axios.get(SUGGEST_URL + "?q=" + this.searchString).then( response => {
          this.suggestions = response.data.suggestions;
        });
      }
    }, 500),
  },

  mounted() {
    document.body.addEventListener("click", this.cancelSuggest);
  },

  beforeDestroy() {
    document.body.removeEventListener("click", this.cancelSuggest);
  },

  methods: {

    clickOption(suggestion: string) {
      this.$emit('chooseOption', { suggestion });
      this.cancelSuggest();
    },

    cancelSuggest() {
      this.suggestions = [];
    },

  },

});

